import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Modal } from "../components/global/Modal/ModalComponent";
import { PHead } from "../components/global/PHead/PHead";
import { MapScreenV2 } from "../components/screens/S-Map/MapScreenV2/MapScreenV2";
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getRestaurantStaticProps } from "../utils/help/staticProps/restaurantStaticProps";

function LocationPage(props: { restaurantInfo: any }) {
  return (
    <>
      <PHead restaurantInfo={props.restaurantInfo} title="Select location" />
      <MapScreenV2 />
      <Modal />
    </>
  );
}

export async function getStaticProps(context: any) {
  const { restaurantInfo, socialMediaInfo } = await getRestaurantStaticProps();

  return {
    props: {
      ...(await serverSideTranslations(context.locale, [
        ...globalTranslationFiles,
        "cart",
        "table-page",
      ])),
      restaurantInfo,
      socialMediaInfo,
      // Will be passed to the page component as props
    },
  };
}

LocationPage.displayName = "LocationPage";

export default LocationPage;
